<!--
 * @Description: 微信推送配置
 * @Version: 1.0
 * @Autor: jinchuan.lee
 * @Date: 2021-06-03 16:49:51
 * @LastEditors: jinchuan.lee
 * @LastEditTime: 2021-06-07 17:52:36
-->
<template>
    <el-dialog
        title="微信推送配置"
        :visible.sync="dialogVisible"
        append-to-body
        :close-on-click-modal='false'
        class="default-dialog c-wxChartSetting"
        width="890px"
   >
   <div class = "c-wxChartSetting-tips">
       <i class="el-icon-warning c-wxChartSetting-tips-icon"></i>
       <span class="c-wxChartSetting-tips-text">绑定微信公众号，按规则推送日记账变动明细，还没有绑定？</span>
       <span class="c-wxChartSetting-tips-jump pointer" @click='handleClickJumpSet'>点击跳转绑定微信</span>
   </div>
   <div class = "c-wxChartSetting-wrapper top15" v-loading = "loading">
       
       <div 
            class = "c-wxChart-item"
            v-for = "item in ruleList"
            :key = "item.id"
       >
            <div class = "c-wxChart-item-label textOver" :title = "item.columnName">{{item.customName}}</div>
            <div  class = "c-wxChart-item-monitor"> <el-checkbox v-model="item.isControl">监控该项</el-checkbox> </div>
            <transition name = "el-fade-in">
                <div 
                    v-if="item.isControl&&(item.customType =='1'|| item.customType=='3' || item.customType=='4' || item.customType=='6')" 
                    class = "c-wxChart-item-range"
                >
                    <el-radio v-model="item.controlType" label="1">全部变动</el-radio>
                    <el-radio v-model="item.controlType" label="0">按规则</el-radio>
                </div>
            </transition>
            <transition name = "el-fade-in">
                <div class='c-wxChart-item-numRange' v-if='item.isControl && item.controlType =="0"&& item.customType=="3"'>
                    <span class='c-wxChart-item-numRange-label'>数值范围：</span>
                    <el-input size='mini' v-model='item.numStart' style='width: 120px;' placeholder="开始"></el-input>
                    <span>&nbsp - &nbsp</span>
                    <el-input size='mini' v-model='item.numEnd' style='width: 120px;' placeholder="结束"></el-input>
                </div>
            </transition>
            <transition name = "el-fade-in">
                <div  class='c-wxChart-item-numRange'  v-if='item.isControl && item.controlType =="0"&& item.customType=="1"'>
                    <span>包含关键字：</span>
                    <el-input size='mini' v-model='item.rule' style='width: 180px;' placeholder="关键字用','号隔开"></el-input>
                </div>
            </transition>
            <transition name = "el-fade-in">
                <div class='c-wxChart-item-numRange'  v-if='item.isControl && item.controlType =="0"&& ( item.customType=="4" || item.customType=="6" )'>
                     <span>包含选项：</span>
                    <el-select 
                        v-model="item.selectList" 
                        multiple placeholder="以包含以下选项时" 
                        style='width: 230px;' 
                        size='mini'
                        collapse-tags
                    >
                        <el-option
                            v-for="i in item.optionList"
                            :key="i.id"
                            :label="i.optionName"
                            :value="i.optionName">
                        </el-option>
                    </el-select>
                </div>
            </transition>
       </div>
       <!-- 提交 -->
       <div class = "c-wxChartSetting-footer center top20">
           <accBtn text = "取消" type = "2" @click = "dialogVisible = false"></accBtn>
           <accBtn text = "保存" @click = "handleSave"></accBtn>
       </div>
   </div>
   </el-dialog>
</template>
<script>
export default {
    props: {
        allData:Array
    },
    data() {
        return {
            dialogVisible: false,
            dataList: [],
            selectList: [],
            loading: false,
            ruleList: [],// 规则数组
        }
    },
    watch: {
        dialogVisible(val) {
            if(val) {
                this.getRuleList();
                this.$emit("closeKeyWatch")
            }else {
                this.$emit("openKeyWatch")
            }
        }
    },
    methods: {
        /**
         * @description: 保存所选配置
         * @param {*}
         * @return {*}
         * @author: jinchuan.lee
         */        
        handleSave() {
            let params = this.$lodash.cloneDeep(this.ruleList);
            let ruleOK = true , tipsText = "";
            for(var i = 0; i < params.length; i++) {
                let item = params[i];
                item.rule = item.rule === null?"":item.rule.trim();
                if(item.customType == "3") {  //数值类型
                    item.numEnd = (item.numEnd || item.numEnd ===0)?item.numEnd:null;
                    item.numStart = (item.numStart || item.numStart ===0)?item.numStart:null;
                    if((item.numEnd===null && item.numStart===null) || isNaN(item.numEnd) || isNaN(item.numStart)) {
                		if(item.isControl && item.controlType=="0") {
                            ruleOK = false;
		                	tipsText = item.customName + "规则必须填且只能是数字！";
                            break;
		                }
                	}
                	item.rule = item.numStart+"-"+item.numEnd;
                }
                if(item.customType=="4" || item.customType=="6") {  // 按钮&&下拉框
                    if(!item.selectList.length && item.isControl && item.controlType=="0") {
                        tipsText = item.customName + "规则至少必须选一个！";
                        ruleOK = false;
                        break;
                    }
                    item.rule = item.selectList.toString();
                }
                if(item.customType=="1" && item.isControl && item.controlType=="0" && item.rule === "") {
                    tipsText = item.customName + "规则必填！";
                    ruleOK = false;
                    break;
                }
                item.isControl = item.isControl?"1":"0";
            }
            if(!ruleOK) return this.$message.warning(tipsText);
            // 开始保存
            this.loading = true;
            this.$http.post('custom/saveCustomControlRule' , {ruleList:params}).then(res=>{
                 this.loading = false;
                if(res&&res.data.code == 1) {
                   this.$message.success("保存成功！")
                   this.dialogVisible = false;
                }
            })
        },
        /**
         * @description: 获取规则数据
         * @param {*}
         * @return {*}
         * @author: jinchuan.lee
         */        
        getRuleList() {
            this.ruleList = [];
            this.loading = true;
            this.$http.post('custom/getCustomControlRule' , {}).then(res=>{
                 this.loading = false;
                if(res&&res.data.code == 1) {
                    let data = res.data.data.map(i=>{
                        i.isControl = i.isControl?true:false;
                        i.numStart = "";
                        i.numEnd = "";
                        i.selectList = [];
                        if(i.customType == "3" && i.rule) {  //数值类型赋值回显
                            i.numStart = i.rule.split("-")[0];
                            i.numEnd = i.rule.split("-")[1];
                        }
                        if((i.customType == "4" || i.customType == "6") && i.rule) {  //数值类型赋值回显
                            i.selectList = i.rule.split(",");
                        }
                        return i;
                        
                    });
                   this.ruleList = data;
                }
            })
        },
        /**
         * @description: 跳转设置绑定微信
         * @param {*}
         * @return {*}
         * @author: jinchuan.lee
         */       
        handleClickJumpSet() {
            this.dialogVisible = false;
            this.$router.push({
                path:'./companyAttributes'
            })
        },
        /**
         * @description: 设置值
         * @param {Array} list 当前字段数组
         * @return {*}
         * @author: jinchuan.lee
         */        
        setList(list) {
            this.dataList = this.$lodash.cloneDeep(list);
        }
    }
}
</script>
<style lang="less" scoped>
    .c-wxChartSetting {
        &-tips {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            &-icon {
                color: orange;
            }
            &-jump {
                color: @click-color;
                text-decoration: underline;
                &:hover {
                    opacity: .8;
                }
            }
            &-text {
                margin-left: 5px;
                font-size: 12px;
            }
        }
        .c-wxChartSetting-wrapper {
            .c-wxChart-item {
                display: flex;
                align-items: center;
                border-bottom: 1px solid @border-color;
                border-right: 1px solid @border-color;
                &:first-child {
                    border-top: 1px solid @border-color;
                }
                &-range {
                     padding: 10px 15px;
                    border-right: 1px solid @border-color;
                }
                &-monitor {
                    padding: 10px 15px;
                    border-right: 1px solid @border-color;
                }
                &-numRange {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    padding: 6px 15px;
                }
                &-label {
                    padding: 10px 15px;
                    box-sizing: border-box;
                    width: 100px;
                    text-align: right;
                    border-right: 1px solid @border-color;
                    border-left: 1px solid @border-color;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/attr/we-chart-push.vue